import React from "react";
import type { SxProps } from "@mui/joy/styles/types";
import { Box, Option } from "@mui/joy";
import type { InstructorStat } from "../../api/stats/Stats.typed";
import {
  instructorEncadrantFilterLabelSx,
  instructorEncadrantFilterSelectFullWidthSx,
  instructorEncadrantFilterWrapperSx,
} from "../../styles/globalStyles";
import DarkTypography from "./DarkTypography";
import DarkSelect from "./DarkSelect";
import { formatInstructorStatDisplayName } from "../stats/instructorNameFormat";

export const INSTRUCTOR_FILTER_ALL = 0;

type InstructorEncadrantFilterProps = {
  value: number;
  onInstructorChange: (instructorId: number) => void;
  options: Pick<InstructorStat, "id" | "first_name" | "last_name">[];
  sx?: SxProps;
};

export default function InstructorEncadrantFilter({
  value,
  onInstructorChange,
  options,
  sx,
}: InstructorEncadrantFilterProps) {
  const handleChange = React.useCallback(
    (_: unknown, val: number | null) => {
      onInstructorChange(val ?? INSTRUCTOR_FILTER_ALL);
    },
    [onInstructorChange],
  );

  return (
    <Box sx={[instructorEncadrantFilterWrapperSx, ...(sx ? [sx] : [])] as SxProps}>
      <DarkTypography level="body-sm" colorVariant="primary" sx={instructorEncadrantFilterLabelSx}>
        Encadrant
      </DarkTypography>
      <DarkSelect
        size="sm"
        value={value}
        onChange={handleChange}
        aria-label="Encadrant"
        sx={instructorEncadrantFilterSelectFullWidthSx}
      >
        <Option value={INSTRUCTOR_FILTER_ALL}>Tous les encadrants</Option>
        {options.map((o) => (
          <Option key={o.id} value={o.id}>
            {formatInstructorStatDisplayName(o)}
          </Option>
        ))}
      </DarkSelect>
    </Box>
  );
}
